export interface LabelPair {
  key: string;
  value: string;
}

export const mapLabelsToPairs = (labels?: Record<string, string> | null): LabelPair[] => {
  if (!labels) {
    return [];
  }
  return Object.entries(labels).map(([key, value]) => ({ key, value }));
};

export const labelPairsToRecord = (
  pairs: LabelPair[]
): { labels: Record<string, string>; error: string | null } => {
  const labels: Record<string, string> = {};
  for (const pair of pairs) {
    const key = pair.key.trim();
    const value = pair.value.trim();
    if (!key && !value) {
      continue;
    }
    if (!key || !value) {
      return { labels: {}, error: 'Labels require both key and value.' };
    }
    if (labels[key]) {
      return { labels: {}, error: `Duplicate label key "${key}".` };
    }
    labels[key] = value;
  }
  return { labels, error: null };
};
